import Editor from './base/editor';
import { not, reads } from '@ember/object/computed';
import { scheduleOnce } from '@ember/runloop';
import Em from 'ember';
export default Editor.extend({
  classNames: ['ic-popup', 'ic-popup-above', 'ic-popup-short', 'is-light-theme', 'composer-text-formatter'],
  formattingOptionStates: reads('composerState.formattingOptionStates'),
  isBoldEnabled: reads('formattingOptionStates.bold.isEnabled'),
  isBoldDisabled: not('isBoldEnabled'),
  isBoldActive: reads('formattingOptionStates.bold.isActive'),
  isBoldInactive: not('isBoldActive'),
  isItalicEnabled: reads('formattingOptionStates.italic.isEnabled'),
  isItalicDisabled: not('isItalicEnabled'),
  isItalicActive: reads('formattingOptionStates.italic.isActive'),
  isItalicInactive: not('isItalicActive'),
  isAnchorEnabled: reads('formattingOptionStates.anchor.isEnabled'),
  isAnchorDisabled: not('isAnchorEnabled'),
  isAnchorActive: reads('formattingOptionStates.anchor.isActive'),
  isAnchorInactive: not('isAnchorActive'),
  isHeadingEnabled: reads('formattingOptionStates.heading.isEnabled'),
  isHeadingDisabled: not('isHeadingEnabled'),
  isHeadingActive: reads('formattingOptionStates.heading.isActive'),
  isHeadingInactive: not('isHeadingActive'),
  isSubheadingEnabled: reads('formattingOptionStates.subheading.isEnabled'),
  isSubheadingDisabled: not('isSubheadingEnabled'),
  isSubheadingActive: reads('formattingOptionStates.subheading.isActive'),
  isSubheadingInactive: not('isSubheadingActive'),
  isCenterEnabled: reads('formattingOptionStates.center.isEnabled'),
  isCenterDisabled: not('isCenterEnabled'),
  isCenterActive: reads('formattingOptionStates.center.isActive'),
  isCenterInactive: not('isCenterActive'),
  recalculatePosition: Em.observer({
    dependentKeys: ['isBoldEnabled', 'isItalicEnabled', 'isAnchorEnabled', 'isHeadingEnabled', 'isCenterEnabled'],
    fn() {
      scheduleOnce('afterRender', this, this.setupEditorDimensions);
    },
    sync: false
  }),
  willDestroyElement() {
    this._super(...arguments);
    // TODO - shouldn't need to do this - See: https://github.com/intercom/intercom/issues/27052
    if (this._unsubscribeFromStreamBindings) {
      this._unsubscribeFromStreamBindings();
    }
  },
  actions: {
    format(style) {
      let propertyName = `is${Em.String.capitalize(style)}Enabled`;
      if (this.get(propertyName)) {
        this.applyActionToSelection?.(style);
      }
    },
    convert(type) {
      let capitalizedType = Em.String.capitalize(type);
      let enabledPropertyName = `is${capitalizedType}Enabled`;
      let activePropertyName = `is${capitalizedType}Active`;
      if (this.get(activePropertyName)) {
        type = 'paragraph';
      }
      if (this.get(enabledPropertyName)) {
        this.applyActionToSelection?.('convertToBlock', {
          type
        });
      }
    },
    center() {
      let alignment = 'center';
      if (this.get('isCenterActive')) {
        alignment = 'left';
      }
      this.align?.(alignment);
    }
  }
});